<template>
  <div>
    <div v-for="(item,index) in imageList" :key="'sceneMaterialImage'+index">
      <scene-material-image :imageInfo="item" @clickMarker="clickMarker"></scene-material-image>
    </div>
  </div>
</template>

<script>
import SceneMaterialImage from "@/views/globe/globe_marker/SceneMaterialImage";

export default {
  name: "SceneMaterialImageEntry",
  components: {SceneMaterialImage},
  props:['imageList'],
  methods:{
    clickMarker(pointInfo){
      this.$emit("clickMarker",pointInfo)
    }
  },
  mounted(){
    console.log(this.imageList)

  }
}
</script>

<style scoped>

</style>